@use '../../../../styles/scss/global/variables/breakpoints';

.vs-fs {
  overflow: hidden;
  position: relative;

  &:hover {
    .vs-fs-btn {
      transition: 0.5s;
      display: none;
      @mixin vs-hover-fs {
        opacity: 0.8;
        display: block;

        &.vs-alt {
          opacity: 1;
        }
      }

      @include breakpoints.tablet-up {
        @include vs-hover-fs;
      }
    }
    .vs-fs-btn.vs-alt {
      display: block;
    }
  }
  .vs-fs-wrapper {
    position: relative;
    perspective: 0em;
    -webkit-perspective: 0rem;

    @include breakpoints.tablet-up {
      max-width: 720px;
    }

    @include breakpoints.desktop-up {
      max-width: 960px;
    }

    @include breakpoints.desktop-plus-up {
      max-width: 1140px;
    }
  }

  .vs-fs-content {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    width: 20000px;
  }

  li {
    display: block;
    touch-action: pan-y !important;
    word-break: break-word;
    @include breakpoints.mobile {
      &.vs-img-small,
      &.vs-img-large {
        height: 200px;
      }
    }
    @include breakpoints.tablet-up {
      &.vs-img-large,
      &.vs-img-small {
        height: 360px;
      }
    }
    @include breakpoints.desktop-up {
      &.vs-img-large {
        height: 500px;
      }
      &.vs-img-small {
        height: 360px;
      }
    }
    &:focus {
      outline-offset: -2px;
      box-shadow: 0 0 0px 2px white;
      outline: dashed black 2px;
    }
    &:focus-within {
      img {
        padding-top: 2px;
        margin-bottom: -2px;
      }
    }
  }
  .vs-fs-btn {
    border: 0px;
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: var(--ds-fs-btn-bg-color, white);
    border-radius: 50%;
    padding: 10px;
    cursor: pointer;
    z-index: 2;

    &:hover,
    &:focus {
      opacity: 1;
      box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.14);
    }
    &:focus {
      span {
        border: 1px dashed var(--ds-fs-btn-border-color, #2c2c2c);
        border-radius: 50%;
        height: 51px;
        width: 51px;
        position: absolute;
        top: 4px;
        left: 4px;
      }
    }

    &::after {
      color: var(--ds-fs-btn-color, #2c2c2c);
      display: inline-block;
      font-family: 'visa-icon', sans-serif;
      font-size: 40px;
      position: relative;
      top: 0px;
    }

    @mixin vs-fs-btn-mixin {
      display: block !important;
      height: 60px;
      opacity: 0;
      width: 61px;

      &.vs-prev {
        left: 25px;
        line-height: normal;

        &::after {
          right: 4px;
          content: '\e71a';
        }
      }

      &.vs-next {
        right: 25px;
        line-height: normal;

        &::after {
          left: 4px;
          content: '\e71b';
        }
      }
    }
    @include breakpoints.tablet-up {
      @include vs-fs-btn-mixin;
    }
    span {
      font-size: 0;
    }
  }

  .fs-transition {
    transition: transform 500ms ease;
    -webkit-transition: transform 500ms ease;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
  }

  .fs-delay {
    transition: transform 2ms, none, 900ms;
    -webkit-transition: transform 2ms, none, 900ms;
  }
  .li-container-style {
    padding-right: 2px;
    padding-left: 2px;
    transform: translate3d(0px, 0px, 0px);
    @include breakpoints.mobile {
      padding-left: 2.5px;
      padding-right: 3px;
      transform: translate3d(0px, 0px, 0px);
    }
  }
  img {
    object-fit: fill;
    max-width: 100%;
  }
  .vs-fs-content {
    @include breakpoints.mobile {
      &.vs-img-large,
      &.vs-img-small {
        img {
          height: 200px;
        }
      }
    }
    @include breakpoints.tablet-up {
      &.vs-img-large,
      &.vs-img-small {
        img {
          height: 360px;
        }
      }
    }
    @include breakpoints.desktop-up {
      &.vs-img-large {
        img {
          height: 500px;
        }
      }
      &.vs-img-small {
        img {
          height: 360px;
        }
      }
    }
  }
}
.fs-image-description {
  color: #2c2c2c;
  background: inherit;
  padding: 20px 20px 30px 20px;
  position: relative;
  display: flex;
  bottom: 4px;
  min-height: 50px;
  overflow-wrap: break-word;
}

.vs-filmstrip-skeleton {
  width: 100%;

  @keyframes shimmer {
    0% { background-position: -1200px 0; }
    100% { background-position: 1200px 0; }
  }

  // Common shimmer background for all skeleton elements
  .shimmer-bg {
    background: linear-gradient(90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%);
    background-size: 1200px 100%;
    animation: shimmer 2s infinite linear;
    border-radius: 4px;
  }

  .vs-fs {
    overflow: hidden;
    position: relative;
    margin: 0;
    padding: 0;

    .vs-fs-skeleton-wrapper {
      position: relative;
      margin: 0 auto;
      padding: 0;

      @include breakpoints.tablet-up {
        max-width: 720px;
      }

      @include breakpoints.desktop-up {
        max-width: 960px;
      }

      @include breakpoints.desktop-plus-up {
        max-width: 1140px;
      }
    }

    .vs-fs-skeleton-content {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0 20px;
      min-height: 200px;
      justify-content: flex-start; // Align items from left like actual content
    }

    .vs-fs-skeleton-item {
      display: block;
      padding: 0 5px;
      position: relative;
      margin-right: 10px; // Add spacing between items to match actual content

      // Match the width and height of actual items
      &.vs-img-small {
        @include breakpoints.mobile {
          width: calc(50% - 10px);
          height: 200px;
        }

        @include breakpoints.tablet-up {
          width: calc(33.33% - 10px);
          height: 360px;
        }

        @include breakpoints.desktop-up {
          width: calc(25% - 10px);
          height: 360px;
        }
      }

      &.vs-img-large {
        @include breakpoints.mobile {
          width: calc(80% - 10px);
          height: 200px;
        }

        @include breakpoints.tablet-up {
          width: calc(50% - 10px);
          height: 360px;
        }

        @include breakpoints.desktop-up {
          width: calc(33.33% - 10px);
          height: 500px;
        }
      }
    }

    .vs-fs-skeleton-image {
      width: 100%;
      height: 100%;
      @extend .shimmer-bg;
    }

    // Navigation buttons
    .vs-fs-skeleton-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 60px;
      width: 60px;
      border-radius: 50%;
      z-index: 2;
      @extend .shimmer-bg;

      &.vs-prev {
        left: 25px;
      }

      &.vs-next {
        right: 25px;
      }

      // Hide on mobile, show on tablet and up
      display: none;
      @include breakpoints.tablet-up {
        display: block;
      }

      span {
        display: block;
        width: 0.75rem;
        height: 0.75rem;
        margin: 0 auto;
        position: relative;
        top: 0.875rem;
      }
    }
  }

  // Caption area
  .vs-fs-skeleton-caption {
    padding: 20px;
    min-height: 80px;
    display: flex;
    flex-direction: column;

    .vs-fs-skeleton-caption-line {
      height: 1rem;
      margin-bottom: 0.75rem;
      @extend .shimmer-bg;

      &:first-child {
        width: 80%;
        height: 1.25rem;
      }

      &:last-child {
        width: 40%;
      }
    }
  }

  .vs-mb-3 {
    margin-bottom: 1.5rem;
  }

  .vs-d-none {
    display: none;
  }
}
